import { MutableRefObject } from 'react'

import { SectionId } from './sectionId'

export const scrollToSection = (
  refs: MutableRefObject<Record<string, HTMLDivElement | null>>,
  id: SectionId
) => {
  refs.current[id]?.scrollIntoView({ behavior: 'smooth' })
}
